import React, { useEffect } from 'react'
import { useTable, useSortBy } from 'react-table'
import PropTypes from 'prop-types'
import Pagination from './pagination'

const Table = ({ columns, data, size, onRowClick, selectedRow, loading, totalRows, pageChangeHandler, currentPage, setCurrentPage, setSortBy = () => {} }) => {


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable({
    columns,
    data,
    manualPagination: true,
    manualSortBy: true,
  },
  useSortBy,
  )

  useEffect(() => {
    setSortBy(sortBy)
  }, [sortBy])

  return (
    <>
      <table className={`table table-hover table-${size}`} {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps([{ className: column.className }])}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>

          {rows.map((row, i) => {
            prepareRow(row)
            const extraClass = "" + row.original.id === selectedRow ? 'active' : ''
            return (
              <tr {...row.getRowProps({ className: extraClass })} onClick={() => onRowClick ? onRowClick(row) : false}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps([
                    { className: cell.column.className }
                  ])}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}

        </tbody>
      </table>
      {totalRows && pageChangeHandler &&
        <>
          <Pagination
            totalRows={totalRows}
            pageChangeHandler={pageChangeHandler}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </>
      }
    </>
  )
}

export default Table

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  size: PropTypes.string,
  loading: PropTypes.bool,
};

Table.defaultProps = {
  columns: [],
  data: [],
  size: 'md',
  loading: false,
};